<template>
    <vs-popup :title="$t('Roles')" :active.sync="visible" id="popup-role" @close="closePopup" ref="vspopup-role">
      <tag-suggestion
              ref="select_sugestion"
              :max="20"
              class="row-start-1"
              column="name"
              orderBy="name"
              model="Role"
              :label="$t('role.selected')"
              v-model="selectedItems"
              :modelToTagMapping="mapModelToTag"
              :placeholderText="$t('form_min_caracter_', [3])"/>
          <!-- Action -->
          <div class="flex flex-row justify-end gap-4 mt-2">
            <b-button  @click="closePopup()"
              variant="primary">{{$t('action.confirm') }}</b-button>
          </div>
    </vs-popup>
</template>

<script>

import RoleService from '@/services/api/RoleService'
import TagSuggestion from '@/components/TagSuggestion.vue'

import {
  BButton
} from 'bootstrap-vue'

export default {
  components: {
    BButton,
    TagSuggestion
  },
  props: {
    visible :{
      type: Boolean,
      default: false
    },
    filters :{
      type: String,
      default: null
    },
    idsSelected:{
      type: Array,
      default: []
    }
  },
  data: () => ({
    roleService: null,
    selectedItems: [],

  }),
  computed: {

  },
  methods: {
    closePopup(value){
      const items = this.handlingItemsNoTag()
      this.$emit('selected', items)
      this.$emit('close', value)
    },
    handlingItemsNoTag(){
      let items = []

      this.selectedItems.forEach(element => {
        items.push(element.data)
      });

      return items;
    },
    mapModelToTag(model) {
      return {
        text: model.name,
        data: model,
        tiClasses: ['ti-valid'],
        classes: 'bg-primary',
      }
    },
    makeModelToTag(){
      this.roleService.getRoles(this.idsSelected).then(
        response => {
          let tags = []
          response.forEach(element => {
            tags.push(this.mapModelToTag(element))
          })

          this.selectedItems = tags
        },
        error => {console.error('whoops')}
      )
    }
  },//End function/method
  beforeMount() {
    this.roleService = RoleService.build(this.$vs)
  },
  mounted() {
    this.makeModelToTag()
  },
  watch: {

  },
}
</script>


<style lang="scss" scoped>
  ::v-deep .vs-popup {
    width: 300px !important;
    height: 400px !important;
  }
  ::v-deep .vs-popup--content{
    overflow: unset !important;
  }
</style>
